/** @jsx jsx */
import { Popover2 } from "@blueprintjs/popover2";
import { css, jsx } from "@emotion/react";
import { LegendItem } from "./LegendItem";

export default function LegendPopOver({children,legendItemProps}) {
    const popOverContent = 
        <div css={popoverCss}>
            {legendItemProps.map((itemProps)=><LegendItem {...itemProps}/>)}
        </div>
    return (
        <Popover2 content={popOverContent}
                  interactionKind="hover"
                  modifiers={{"arrow":{"enabled":true}}}>
            {children}
        </Popover2>
    )
}

const popoverCss = css`
    padding: 1em;
    background: white;
    border-radius: 4px;
    overflow-y: auto;
    max-height: 100vh;
    max-width: 50vw;
`